module.exports = __webpack_public_path__ + "static/media/Workday_Step1b_Image4r.d68cfc87.jpg";